var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { useEffect, useState } from 'react';
import { LoadState } from './types';
var DeferredPromise = /** @class */ (function () {
    function DeferredPromise() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return DeferredPromise;
}());
/**
 * When given a Domain will return a function that, when called, returns a promise.
 *
 * When the Domain is loaded, the promise will resolve with the Domain's `data` value.
 *
 * When the Domain is failed, the promise will reject with the Domain's `error` value.
 */
export function useAwaitData(domain) {
    var _a = __read(useState([]), 2), deferredPromises = _a[0], setDeferredPromises = _a[1];
    useEffect(function () {
        if (deferredPromises.length < 1)
            return;
        if (domain.status.loadState !== LoadState.LOADED &&
            domain.status.loadState !== LoadState.FAILED)
            return;
        // Resolve or reject all deferred promises in queue based on the domain's status and clear the queue
        deferredPromises.forEach(function (deferred) {
            var _a;
            if (domain.status.loadState === LoadState.LOADED) {
                deferred.resolve(domain.data);
                return;
            }
            deferred.reject((_a = domain.error) !== null && _a !== void 0 ? _a : new Error('Data domain error.'));
        });
        setDeferredPromises([]);
    }, [deferredPromises, domain.status.loadState]);
    var getDomain = function () {
        // Add deferred promsie to queue and return unwrapped promise
        var deferred = new DeferredPromise();
        setDeferredPromises(function (curr) { return __spread(curr, [deferred]); });
        return deferred.promise;
    };
    return getDomain;
}
//# sourceMappingURL=use-await-data.js.map